import React, { useContext } from "react";
import { View } from "react-native";
import { Dispatch } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { orderDetailsStyles as styles } from "./styles";
import { withForwardRef } from "@/app/utils/withForwardRef";
import Header from "./Header";
import { getLineItems } from "@/app/utils/orderHistory";
import { getAllProductsById } from "@/app/selectors/product";
import Lines from "./Lines";
import ReprintButton from "./ReprintButton";
import { TposBasketContext } from "@/app/contexts";
import { printReceiptAsync } from "@/app/actions/mode";
import { PrintReceiptAsyncAction } from "@/app/types/printer";

const OrderDetails = (): JSX.Element => {
  const dispatch = useDispatch<Dispatch<PrintReceiptAsyncAction>>();
  const productsById = useSelector(getAllProductsById);
  const { selectedOrder } = useContext(TposBasketContext);

  if (!selectedOrder) {
    return <></>;
  }
  const items = getLineItems(selectedOrder, productsById);

  return (
    <View style={styles.container}>
      <Header order={selectedOrder} />
      <Lines items={items} />
      <ReprintButton
        onReprintPress={() => {
          dispatch(printReceiptAsync(selectedOrder));
        }}
      />
    </View>
  );
};

export default withForwardRef<HTMLDivElement>(OrderDetails);
